<template>
  <v-sheet dark>
    <v-row align="center" style="position: relative;">
      <v-col cols="2">
        <router-link to="/">
          <v-img dark class="ml-6" :src="`${Utility.RES_SERVER}/static/img/logo-dark.png`" contain width="180" height="35" />
        </router-link>
      </v-col>
      <v-col cols="6">
        <v-row dense justify="center">
          <v-col cols="3">
            <v-btn x-large rounded text block @click="$router.push('/tutorial')">
              <v-icon class="mr-2" color="primary">mdi-play-box</v-icon>
              视频教程
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn x-large rounded text block @click="$router.push('/project')">
              <v-icon class="mr-2" color="orange">mdi-dna</v-icon>
              我的项目
            </v-btn>
          </v-col>
          <!-- <v-col cols="2">
            <v-btn x-large text rounded block @click="$router.push('/report')">
              <v-icon class="mr-2" color="teal">mdi-lock-pattern</v-icon>
              流程
            </v-btn>
          </v-col> -->
          <v-col cols="2">
            <v-btn x-large text rounded block @click="$router.push('/tool')">
              <v-icon class="mr-2" color="red accent-3">mdi-fire</v-icon>
              工具
            </v-btn>
          </v-col>
          <!-- <v-col cols="2">
            <v-btn x-large text rounded block @click="()=>{}">
              <v-icon class="mr-2" color="teal">mdi-firebase</v-icon>
              云课堂
            </v-btn>
          </v-col> -->
          <span style="color: #FF0000; position: absolute;bottom: 0;margin-left: 5px;">
          您正在使用的是旧版云平台，现已推出新版云平台，欢迎使用！
          <span style="color: #409eff; cursor: pointer;" @click="jumpNewReport()">点击此处前往</span>
        </span>
        </v-row>
      </v-col>
      <v-col cols="4">
        <v-row dense justify="end">
          <v-col cols="auto" class="pr-8">
            <template v-if="token">

              <!-- user message -->
              <v-menu v-model="messageVisible" open-on-hover offset-y z-index="99">
                <template v-slot:activator="{ on }">
                  <v-badge class="mr-4" color="red" :content="userMessageCount" :value="userMessageCount" overlap>
                    <v-btn fab light small v-on="on" @click="onUserMessageMore">
                      <v-icon color="purple">mdi-bell</v-icon>
                    </v-btn>
                  </v-badge>
                </template>
                <v-card width="240" flat>
                  <v-card-text class="pa-0">
                    <v-row v-if="userMessageCount==0" justify="center">
                      <v-col cols="auto" class="text-subtitle-1">暂无消息</v-col>
                    </v-row>
                    <v-list dense v-else>
                      <v-list-item>
                        <v-list-item-content class="text-right d-inline">
                          <a class="caption deep-orange--text" @click="onUserMessageReadAll">全部已读</a>
                          <a class="ml-2 caption deep-orange--text" @click="onUserMessageMore">更多</a>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-for="(item,index) in userMessages" :key="index" @click="onUserMessageClick(index)">
                        <v-list-item-content class="primary--text" v-text="item.title"></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-menu>

              <!-- profile -->
              <v-menu v-model="profileVisible" open-on-hover :close-on-content-click="false" offset-y z-index="99">
                <template v-slot:activator="{ on }">
                  <v-btn light fab small v-on="on">
                    <v-avatar height="42" width="42" style="min-width:20px;min-height:20px;" @click="toProfileSummary">
                      <v-img v-if="!!avatar" style="min-width:20px;min-height:20px;" :src="avatar" contain></v-img>
                    </v-avatar>
                  </v-btn>
                </template>
                <v-card width="265" flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="4">
                        <v-avatar height="68" width="68">
                          <v-img v-if="!!avatar" style="min-width:20px;min-height:20px;" :src="avatar" contain></v-img>
                        </v-avatar>
                      </v-col>
                      <v-col cols="8">
                        <p class="text-subtitle-2">姓名：{{username}}</p>
                        <p>
                          <v-row no-gutters>
                            <v-col cols="auto" class="text-subtitle-2">
                              可用积分：
                            </v-col>
                            <v-col>
                              <template v-if="!pointVisible">
                                <v-skeleton-loader height="22" type="button"></v-skeleton-loader>
                              </template>
                              <template v-else>
                                <a class="orange--text" @click="$router.push('/profile/point')">{{userpoint}}</a>
                                <v-icon x-small color="deep-orange" class="ml-2" @click="reloadPoint">mdi-autorenew</v-icon>
                              </template>
                            </v-col>
                            <v-col cols="12">
                              <router-link class="primary--text text-button text-decoration-none" to="/profile/point/order">充值</router-link>
                            </v-col>
                          </v-row>
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <v-divider />
                      </v-col>
                      <v-col cols="12">
                        <v-row dense justify="center">
                          <v-col cols="auto">
                            <a @click="toProfileSummary">个人中心</a>
                            <span class="font-weight-bold grey--text"> | </span>
                            <a @click="toProfileToolTask">分析任务</a>
                            <span class="font-weight-bold grey--text"> | </span>
                            <a @click="toProfileReport">我的报告</a>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="pl-2 pr-2">
                        <v-btn block tile color="red" dark @click="onLogout">注 销</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>

            <!-- login & registry -->
            <template v-else>
              <router-link to="/login" class="text-decoration-none body-1 ml-4 amber--text">登录</router-link>
              <span class="caption ml-1">/</span>
              <router-link to="/registry" class="text-decoration-none body-1 ml-1 mr-4 amber--text">注册</router-link>
            </template>
          </v-col>
        </v-row>
      </v-col>

    </v-row>

    <v-snackbar v-model="userMessageTip" absolute transition="slide-y-transition" style="position: fixed;z-index:99991;" color="teal" dark rounded="0" :timeout="6000" top right>
      <div v-if="userMessageTipItem">
        <a class="white--text" @click="onUserMessageClick()">{{userMessageTipItem.title}}</a>
        <!-- <router-link :to="userMessageTipItem.url">{{userMessageTipItem.title}}</router-link> -->
      </div>
    </v-snackbar>

    <logger />

    <v-snackbar v-model="browserWarn" outlined tile color="deep-orange" top :timeout=-1 class="mt-2">
      <a @click="browserWarn=false">
        <v-badge color="deep-orange" icon="mdi-close" overlap style="position: absolute;right:0;top:0;"></v-badge>
      </a>
      <div style="min-width:300px;min-height:190px;">
        <v-row justify="center">
          <v-col cols="auto" class="text-h6">
            为了能更好的使用中科生信云平台,建议使用现代浏览器
          </v-col>
          <v-col cols="12"></v-col>
          <v-col cols="auto">
            <a href="https://www.firefox.com.cn/" target="_blank">
              <v-img :src="`${Utility.RES_SERVER}/static/img/logo-firefox.png`" width="60" contain></v-img>
            </a>
          </v-col>
          <v-col cols="auto">
            <a href="https://www.google.cn/chrome/" target="_blank">
              <v-img :src="`${Utility.RES_SERVER}/static/img/logo-chrome.svg`" width="60" contain></v-img>
            </a>
          </v-col>
        </v-row>
      </div>
    </v-snackbar>
  </v-sheet>
</template>
<script>
/* eslint-disable no-console */
import { getUserProfile, queryUserMessage, userMessageRead, userMessageReadAll, userLogout } from '@/plugins/api';
import { mapState } from 'vuex';
import Vue from 'vue';
let userMessageTimer;
export default {
  computed: {
    ...mapState({
      token: state => state.token,
      avatar: state => state.avatar,
      username: state => state.username,
      userpoint: state => state.userpoint,
    })
  },
  data () {
    return {
      userBillData: {},
      profileVisible: false,
      userMessages: [],
      userMessageCount: 0,
      userMessageTip: false,
      userMessageTipItem: null,
      messageVisible: false,
      userMessageInteral: 10000,
      pointVisible: true,
      browserWarn: false,
    }
  },
  created () {
    this.init();
  },
  mounted () {
    let ua = navigator.userAgent.toLowerCase();
    let firefox = ua.match(/firefox\/([\d.]+)/), chrome = ua.match(/chrome\/([\d.]+)/);
    if (!firefox && !chrome) this.browserWarn = true;
  },
  watch: {
    // messageVisible (v) {
    //   if (v) this.loadMessage();
    // }
    token (v) {
      if (v) {
        if (userMessageTimer == null) this.initUserMessageTimer();
      } else {
        clearInterval(userMessageTimer);
        userMessageTimer = null;
      }
    }
  },
  methods: {
    init () {
      let token = Vue.ls.get('token');
      this.$store.commit('setToken', token);
      if (token) {
        this.loadMessage();
        this.loadProfile();
        this.initUserMessageTimer();
      }
    },
    initUserMessageTimer () {
      userMessageTimer = setInterval(() => {
        if (this.$store.state.loadingNum) return;
        let n1 = this.userMessageCount;
        this.loadMessage(() => {
          let n2 = this.userMessageCount;
          if (n1 != n2 && n2 > n1 && n2 > 0) { // 仅显示最后一个
            this.userMessageTip = true;
            this.userMessageTipItem = this.userMessages[n2 - 1];
          }
        });
      }, this.userMessageInteral)
    },
    loadProfile () {
      getUserProfile().then((res) => {
        this.userBillData = res.data;
        let avatar = `${this.Utility.RES_SERVER}/avatar/${this.userBillData.avatar}?ts=${new Date().getTime()}`;
        this.$store.commit('setAvatar', avatar);
        this.$store.commit('setUsername', this.userBillData.name);
        this.$store.commit('setUserpoint', this.userBillData.point);
      })
    },
    reloadPoint () {
      this.pointVisible = false;
      setTimeout(() => {
        getUserProfile().then((res) => {
          this.userBillData.point = res.data.point;
          this.$store.commit('setUserpoint', this.userBillData.point);
          this.pointVisible = true;
        })
      }, 1500)
    },
    loadMessage (callback) {
      queryUserMessage({ type: 0, pagination: { index: 1, size: 10 } }, false).then(res => {
        let d = res.data || [];
        this.userMessages = d;
        this.userMessageCount = d.length;
        if (callback) callback();
      }).catch(() => {
        clearInterval(userMessageTimer);
      })
    },
    jumpNewReport() {
      window.location.href = window.location.origin + `/plus/#/`
    },
    onUserMessageClick (index) {
      if (index == null) index = this.userMessageCount - 1;
      let item = this.userMessages[index];
      if (!item.readFlag) {
        userMessageRead(item.id);
        this.userMessages.splice(index, 1);
        this.userMessageCount--;
      }
      if (item.newVersionFlag == '1') {
        window.open(item.url, '_blank')
      } else {
        this.$router.push(item.url);
      }
      
    },
    onUserMessageReadAll () {
      userMessageReadAll().then(() => {
        this.userMessages = [];
        this.userMessageCount = 0;
      })
    },
    onUserMessageMore () {
      this.$router.push('/profile/message');
    },
    onLogout () {
      this.$message.confirm('您确定要注销吗？', () => {
        userLogout();
      })
    },
    toProfileSummary () {
      this.profileVisible = false;
      this.$router.push('/profile/summary');
    },
    toProfileToolTask () {
      this.profileVisible = false;
      this.$router.push('/profile/tool/task');
    },
    toProfileReport () {
      this.profileVisible = false;
      this.$router.push('/project');
    },
  }
}
</script>